import React, { useState, useEffect } from 'react';
import { Modal, Card, Empty, Grid } from 'antd';
import {
  BookOutlined,
  PlusCircleOutlined,
  SettingOutlined,
  AlertOutlined,
  EyeOutlined,
  DesktopOutlined,
} from '@ant-design/icons';
import { parseMarkdown } from '../../../TagHelpCenter/MarkdownParser';
import AppSpinner from '../../../Tasks/components/shared/AppSpinner';
import '../../../../shared/components/HelpCenterModal/_help-content.scss';
import { modal } from '../../../Tasks/configs/designTokens';
import '../../styles/index.scss';

const { useBreakpoint } = Grid;

const helpSections = [
  {
    id: 'create-tags',
    title: 'Create a Tag',
    icon: <DesktopOutlined />,
    filename: 'help-center%2Fcreate-tags.md',
  },
  {
    id: 'install-tags',
    title: 'Tag Installation via Google Tag Manager',
    icon: <PlusCircleOutlined />,
    filename: 'help-center%2Finstall-tags.md',
  },
  {
    id: 'test-tags',
    title: 'Tag Testing',
    icon: <SettingOutlined />,
    filename: 'help-center%2Ftest-tags.md',
  },
  {
    id: 'conversion-tags',
    title: 'Paid Search Tag Conversion Setup',
    icon: <AlertOutlined />,
    filename: 'help-center%2Fconversion-tags.md',
  },
  {
    id: 'check-tags',
    title: 'Checking Paid Search Tag Implementation',
    icon: <EyeOutlined />,
    filename: 'help-center%2Fcheck-tags.md',
  },
];

const TagHelpCenterModal = ({ visible, onClose }) => {
  const screens = useBreakpoint();
  const isMobile = !screens.md;
  const [loading, setLoading] = useState(true);
  const [markdownContent, setMarkdownContent] = useState('');
  const [selectedId, setSelectedId] = useState('create-tags');

  useEffect(() => {
    if (!visible) return;

    const activeSection = helpSections.find((section) => section.id === selectedId);
    if (!activeSection) return;

    setLoading(true);
    fetch(
      `https://internal-service.dmp.mediajel.ninja/api/docs/html?filename=${activeSection.filename}`
    )
      .then((res) => res.text())
      .then((content) => {
        setMarkdownContent(content);
        setLoading(false);
      })
      .catch((err) => {
        console.error('Error loading markdown:', err);
        setLoading(false);
      });
  }, [selectedId, visible]);

  const parsedContent = markdownContent ? parseMarkdown(markdownContent) : '';
  const activeSection = helpSections.find((section) => section.id === selectedId);

  return (
    <Modal
      title={
        <span className="tags-help-modal__title">
          <BookOutlined className="tags-help-modal__title-icon" />
          Tag Help Center
        </span>
      }
      visible={visible}
      onCancel={onClose}
      footer={null}
      width={modal.wide}
      centered
      wrapClassName="tags-modal"
      className="tags-help-modal"
      bodyStyle={{ padding: 0 }}
    >
      <div className={`tags-help-modal__layout${isMobile ? ' tags-help-modal__layout--mobile' : ''}`}>
        <div className="tags-help-modal__sidebar">
          <ul className="tags-help-modal__topics">
            {helpSections.map((section) => (
              <li
                key={section.id}
                className={`tags-help-modal__topic${selectedId === section.id ? ' tags-help-modal__topic--active' : ''}`}
                onClick={() => setSelectedId(section.id)}
              >
                {section.icon}
                <span>{section.title}</span>
              </li>
            ))}
          </ul>
        </div>
        <div className="tags-help-modal__content">
          {loading ? (
            <div className="tags-help-modal__loading">
              <AppSpinner size="large" tip="Loading help documentation..." />
            </div>
          ) : (
            <Card
              title={
                <span>
                  {activeSection && activeSection.icon} {activeSection && activeSection.title}
                </span>
              }
              bordered={false}
              className="tags-help-modal__card"
            >
              {parsedContent ? (
                <div
                  className="tag-help-content"
                  dangerouslySetInnerHTML={{ __html: parsedContent }}
                />
              ) : (
                <Empty description="No documentation available" />
              )}
            </Card>
          )}
        </div>
      </div>
    </Modal>
  );
};

export default TagHelpCenterModal;
